// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TooltipPresentationProps } from "@conklin/MobiusOverrides/Tooltip";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { xBaseTheme } from "@conklin/XDL/types";
import { color, getSystemColor } from "@conklin/XDL/Utilities";
import Info from "@insite/mobius/Icons/Info";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        extendedStyles: {
            tooltipContent: {
                css: css`
                    background-color: ${color("common.white")};
                    max-width: 240px;
                    border-radius: 0;
                    min-width: 140px;
                    box-shadow: 0 2px 4px 0 ${color("common.black", 0.1)};
                    border: 1px solid ${color("common.border")};
                    border-radius: 8px;
                    .tooltipInfo {
                        display: flex;
                        flex-direction: column;
                        flex: 0 0 auto;
                        padding: 12px;
                    }
                `,
            },
            tooltipArrow: {
                stroke: `${getSystemColor("common.border")}`,
                fill: `${getSystemColor("common.white")}`,
                width: 23,
                height: 15,
                tipRadius: 0,
            },
            triggerWrapper: {
                css: css`
                    display: inline-block;
                    height: fit-content;
                    width: fit-content;
                    margin-left: 8px;
                    margin-right: 8px;
                `,
            },
        },
        iconProps: {
            src: Info,
            size: 12,
            color: "common.ui9",
        },
        typographyProps: {
            size: 14,
            weight: fontConfig.weight.regular,
            color: "text.main",
            css: css`
                line-height: 22px;
                text-align: left;
                letter-spacing: 0;
                white-space: break-spaces;
                word-break: break-word;
                &:hover {
                    text-decoration: none;
                }
            `,
        },
    } as TooltipPresentationProps,
} as xBaseTheme["tooltip"];
